// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-n_fP","advertDetailContactGroup__header":"c-n_fQ","advertDetailContactGroup__value":"c-n_fR"};